import { Badge, BadgeProps, styled } from '@mui/material'
import React from 'react'

/**
 * StyledBadge component
 * This component styles the MUI Badge component for chat notifications.
 * It customizes the badge appearance and position.
 *
 * @param {BadgeProps} props - The properties for the badge component.
 * @returns {JSX.Element} The rendered badge component.
 */
const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
  width: '100%',
  '& .MuiBadge-badge': {
    top: '20%'
  }
}))

/**
 * BadgeChat component
 * This component renders a styled badge for chat notifications.
 * It uses MUI's Badge component and allows for custom styling.
 *
 * @param {BadgeProps} props - The properties for the badge component.
 * @returns {JSX.Element} The rendered badge component.
 */
const BadgeChat: React.FC<BadgeProps> = props => {
  return <StyledBadge {...props} />
}

export default BadgeChat
